import type { IWarehouseApi } from "../../../api/WarehouseApi";
import { Box as BoxModel } from "../../../stores/Box";
import { type INavigationStore, Screens } from "../../../stores/navigation";
import { normalizeTypeTags } from "../../../utils/typeTags";
import { normalizeDeleteReason } from "../../shared/use-cases/delete-flow";

interface DeleteCurrentBoxAndNavigateInput {
  api: IWarehouseApi;
  navigationStore: INavigationStore;
  box: BoxModel;
  deleteReason?: string | null;
}

export async function deleteCurrentBoxAndNavigate({
  api,
  box,
  navigationStore,
  deleteReason,
}: DeleteCurrentBoxAndNavigateInput): Promise<void> {
  await api.deleteBox(box.id, normalizeDeleteReason(deleteReason));

  const parentId = box.parentId?.trim() || "";
  if (parentId) {
    try {
      const parent = await api.getBoxById(parentId);
      if (parent) {
        const parentModel = new BoxModel({
          id: parent.id,
          name: parent.name,
          photo: parent.photo,
          typeTags: normalizeTypeTags(parent.typeTags),
          description: parent.description,
          parentId: parent.parentId,
        });
        navigationStore.setScreen(Screens.Box, parentModel);
        return;
      }
    } catch {
      // If parent loading fails, fallback to Main screen.
    }
  }

  navigationStore.setScreen(Screens.Main);
}
